import * as React from "react";
const SvgIconSquare = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, width: 18, height: 18, rx: 2, ry: 2 }));
export { SvgIconSquare as ReactComponent };
